const PhoneNumberRegex = (phone) => {
    let str = phone;
    let result = str.match(
        /^(09)[0-9]{9}$/
    );
    return result;


}
export default PhoneNumberRegex;